export default __webpack_public_path__ + "static/media/gam-1.c7b1e04d.png";